import {useComponentVisibility} from "@shared/hooks";
import {DropdownModel} from "@components/dropdown";
import {TicketFilterOptions} from "@pages/tickets/models/ticket-list-type";
import {useTicketHandler} from "@pages/tickets/hooks/useTicketHandler";
import {useDispatch, useSelector} from "react-redux";

import {useTicketDropdownLabels} from "@pages/tickets/hooks/useTicketDropdownLabels";
import {selectTicketDropdownState} from "@pages/tickets/store/tickets.selectors";
import {setActiveTickets, setClosedAndSolvedTickets, setShowAll} from "@pages/tickets/store/tickets.slice";

export const useTicketDropdownMenu = () => {
    const [dropdownVisibility, setDropdownVisibility, elementRef] = useComponentVisibility<HTMLDivElement>(false);
    const currentDropdownOption = useSelector(selectTicketDropdownState);
    const {fetchAllTickets, fetchActiveTickets, fetchClosedAndSolvedTickets} = useTicketHandler();
    const dispatch = useDispatch();

    const {getLabel} = useTicketDropdownLabels();


    const dropdownModel: DropdownModel = {
        defaultValue: currentDropdownOption,
        isVisible: true,
        items: [
            {label: getLabel(TicketFilterOptions.ShowAllTicket), value: TicketFilterOptions.ShowAllTicket, className: 'text-base'},
            {label: getLabel(TicketFilterOptions.ActiveTickets), value: TicketFilterOptions.ActiveTickets, className: 'text-base'},
            {label: getLabel(TicketFilterOptions.SolvedAndClosed), value: TicketFilterOptions.SolvedAndClosed, className: 'text-base'},
        ],
        onClick: (value: string) => {
            switch (value) {
                case TicketFilterOptions.ShowAllTicket:
                    fetchAllTickets();
                    dispatch(setShowAll());
                    break;
                case TicketFilterOptions.ActiveTickets:
                    fetchActiveTickets();
                    dispatch(setActiveTickets());
                    break;
                case TicketFilterOptions.SolvedAndClosed:
                    fetchClosedAndSolvedTickets();
                    dispatch(setClosedAndSolvedTickets());
                    break;
            }
            setDropdownVisibility(false);
        }
    }

    return {
        dropdownVisibility,
        setDropdownVisibility,
        selectedOption: currentDropdownOption,
        elementRef,
        dropdownModel
    }
}
